/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ComponentProps, ReactElement } from 'react';
import { Children, isValidElement } from 'react';
import { css } from '@compiled/react';

import { jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import type { DecisionList as OriginalDecisionList } from '@atlaskit/renderer/nodes';

import type { LightNodeProps } from '../LightNodeObserver.ts';

const listStyle = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Match Platform's specificity over renderer ordered-list styles.
	'&&': { listStyleType: 'none', paddingLeft: token('space.0') },
});

export const DecisionList = ({
	children,
	lightNodeRef,
	localId,
}: ComponentProps<typeof OriginalDecisionList> &
	LightNodeProps & { localId?: string }): ReactElement | null => {
	if (Children.count(children) === 0) return null;
	return (
		<ol
			ref={lightNodeRef}
			css={listStyle}
			data-decision-list-local-id={localId ?? ''}
			data-node-type="decisionList"
		>
			{Children.map(children, (child) => (
				<li
					data-decision-local-id={
						isValidElement<{ localId?: string }>(child) ? child.props.localId || '' : ''
					}
					data-decision-state="DECIDED"
				>
					{child}
				</li>
			))}
		</ol>
	);
};
